import {
  GET_SIDEBAR_COUNT,
  GET_SIDEBAR_COUNT_SUCCESS,
  GET_SIDEBAR_COUNT_FAILURE,
  UPDATE_SIDEBAR_COUNT,
  UPDATE_SIDEBAR_COUNT_SUCCESS,
  UPDATE_SIDEBAR_COUNT_FAILURE,
} from "../constants";

const initialState = {
  sidebarCount: {},
  isLoading: false,
  error: null,
};

export default function SidebarCountReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SIDEBAR_COUNT:
    case UPDATE_SIDEBAR_COUNT:
      state = {
        ...state,
        isLoading: true,
        error: null,
      };
      break;
    case GET_SIDEBAR_COUNT_SUCCESS:
      state = {
        ...state,
        sidebarCount: action.payload,
        isLoading: false,
      };
      break;
    case UPDATE_SIDEBAR_COUNT_SUCCESS:
      state = {
        ...state,
        sidebarCount: action.payload,
        isLoading: false,
      };
      break;

    case GET_SIDEBAR_COUNT_FAILURE:
      state = {
        ...state,
        sidebarCount: {},
        isLoading: false,
        error: action.payload,
      };
      break;
    case UPDATE_SIDEBAR_COUNT_FAILURE:
      state = {
        ...state,
        isLoading: false,
        error: action.payload,
      };
      break;
    default:
      break;
  }

  return state;
}
